import { buildPermission } from "portal/utils/auth";
import { ComponentType, FunctionComponent } from "react";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import {
  useAuthorizationRequired,
  withAuthorizationRequired,
} from "portal/components/auth/WithAuthorizationRequired";
import { withAuthenticationRequired } from "@auth0/auth0-react";

/** Top-level customer enablement page: Carbon technical only. */
export const carbonCropsPageReadStatement = buildPermission(
  PermissionAction.read,
  PermissionResource.crops_advanced,
  PermissionDomain.all
);

export const carbonCropsPageUpdateStatement = buildPermission(
  PermissionAction.update,
  PermissionResource.crops_advanced,
  PermissionDomain.all
);

export const useCanSeeCarbonCropsPage = (): boolean =>
  useAuthorizationRequired(carbonCropsPageReadStatement);

export const useCanUpdateCarbonCropsPage = (): boolean =>
  useAuthorizationRequired(carbonCropsPageUpdateStatement);

export const withCarbonCropsPageReadAccess = <P extends object>(
  Component: ComponentType<P>
): FunctionComponent<P> =>
  withAuthenticationRequired(
    withAuthorizationRequired(carbonCropsPageReadStatement, Component)
  );
